let _audioCtx = null
const ensureAudioCtx = () => {
  if (_audioCtx) return _audioCtx
  try {
    _audioCtx = new (window.AudioContext || window.webkitAudioContext)()
  } catch (e) {
    _audioCtx = null
  }
  return _audioCtx
}

let _activeSoundOscs = []

const tickSound = (freq) => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  try {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.type = 'square'
    osc.frequency.value = freq || 1200
    const t = ctx.currentTime
    gain.gain.setValueAtTime(0.05, t)
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.05)
    osc.connect(gain).connect(ctx.destination)
    osc.start(t)
    osc.stop(t + 0.06)
  } catch (e) {}
}

const dingSound = () => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  try {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.type = 'triangle'
    osc.frequency.setValueAtTime(1600, ctx.currentTime)
    osc.frequency.exponentialRampToValueAtTime(2400, ctx.currentTime + 0.12)
    gain.gain.setValueAtTime(0.12, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.4)
    osc.connect(gain).connect(ctx.destination)
    osc.start()
    osc.stop(ctx.currentTime + 0.42)
  } catch (e) {}
}

const popSound = (freq) => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  try {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.type = 'triangle'
    const t = ctx.currentTime
    const f = freq || 1200
    osc.frequency.setValueAtTime(f * 0.78, t)
    osc.frequency.exponentialRampToValueAtTime(f, t + 0.06)
    gain.gain.setValueAtTime(0.09, t)
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.12)
    osc.connect(gain).connect(ctx.destination)
    osc.start(t)
    osc.stop(t + 0.14)
  } catch (e) {}
}

const fanfareSound = (tier) => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  const t = ctx.currentTime
  const chord =
    tier >= 3
      ? [523, 659, 784, 1047, 1319]
      : tier === 2
        ? [523, 659, 784, 1047]
        : [523, 659, 784]
  chord.forEach((f, i) => {
    const osc = ctx.createOscillator()
    const g = ctx.createGain()
    osc.type = 'triangle'
    osc.frequency.setValueAtTime(f, t + i * 0.07)
    g.gain.setValueAtTime(0.0001, t + i * 0.07)
    g.gain.linearRampToValueAtTime(0.085, t + i * 0.07 + 0.01)
    g.gain.exponentialRampToValueAtTime(0.0001, t + i * 0.07 + 0.45)
    osc.connect(g).connect(ctx.destination)
    osc.start(t + i * 0.07)
    osc.stop(t + i * 0.07 + 0.48)
  })
}

const clawSound = () => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  try {
    const t = ctx.currentTime
    const osc = ctx.createOscillator()
    const g = ctx.createGain()
    osc.type = 'triangle'
    osc.frequency.setValueAtTime(1600, t)
    osc.frequency.exponentialRampToValueAtTime(2400, t + 0.09)
    g.gain.setValueAtTime(0.09, t)
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.16)
    osc.connect(g).connect(ctx.destination)
    osc.start(t)
    osc.stop(t + 0.18)
    const osc2 = ctx.createOscillator()
    const g2 = ctx.createGain()
    osc2.type = 'sine'
    osc2.frequency.setValueAtTime(3200, t + 0.02)
    osc2.frequency.exponentialRampToValueAtTime(4000, t + 0.08)
    g2.gain.setValueAtTime(0.05, t + 0.02)
    g2.gain.exponentialRampToValueAtTime(0.0001, t + 0.14)
    osc2.connect(g2).connect(ctx.destination)
    osc2.start(t + 0.02)
    osc2.stop(t + 0.16)
  } catch (e) {}
}

const jumpSound = () => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  try {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.type = 'sine'
    const t = ctx.currentTime
    osc.frequency.setValueAtTime(420, t)
    osc.frequency.exponentialRampToValueAtTime(960, t + 0.08)
    gain.gain.setValueAtTime(0.12, t)
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.13)
    osc.connect(gain).connect(ctx.destination)
    osc.start(t)
    osc.stop(t + 0.15)
  } catch (e) {}
}

const hitSound = () => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  try {
    const t = ctx.currentTime
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.type = 'square'
    osc.frequency.setValueAtTime(140, t)
    osc.frequency.exponentialRampToValueAtTime(50, t + 0.18)
    gain.gain.setValueAtTime(0.18, t)
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.22)
    osc.connect(gain).connect(ctx.destination)
    osc.start(t)
    osc.stop(t + 0.24)

    const bufLen = Math.floor(ctx.sampleRate * 0.08)
    const buf = ctx.createBuffer(1, bufLen, ctx.sampleRate)
    const data = buf.getChannelData(0)
    for (let i = 0; i < bufLen; i++) {
      data[i] = (Math.random() * 2 - 1) * (1 - i / bufLen)
    }
    const noise = ctx.createBufferSource()
    noise.buffer = buf
    const ng = ctx.createGain()
    ng.gain.setValueAtTime(0.18, t)
    ng.gain.exponentialRampToValueAtTime(0.0001, t + 0.09)
    noise.connect(ng).connect(ctx.destination)
    noise.start(t)
    noise.stop(t + 0.1)
  } catch (e) {}
}

const stopEffects = () => {
  _activeSoundOscs.forEach((osc) => {
    try {
      osc.stop()
    } catch (_) {}
  })
  _activeSoundOscs = []
}

const playComboEffectSound = (duration) => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  const dur = Math.max(0.5, duration || 5)
  try {
    const t = ctx.currentTime
    const chord = [523, 659, 784, 988]
    const noteDur = 0.55
    const gap = 0.25
    let cur = t
    const endT = t + dur
    while (cur < endT) {
      const rowStart = cur
      for (let i = 0; i < chord.length; i++) {
        const startAt = rowStart + i * 0.04
        if (startAt >= endT) continue
        const osc = ctx.createOscillator()
        const g = ctx.createGain()
        osc.type = 'sine'
        osc.frequency.setValueAtTime(chord[i], startAt)
        g.gain.setValueAtTime(0.0001, startAt)
        g.gain.linearRampToValueAtTime(0.038, startAt + 0.1)
        g.gain.linearRampToValueAtTime(0.018, startAt + noteDur * 0.55)
        g.gain.exponentialRampToValueAtTime(0.0001, startAt + noteDur)
        osc.connect(g).connect(ctx.destination)
        osc.start(startAt)
        osc.stop(startAt + noteDur + 0.05)
        _activeSoundOscs.push(osc)
      }
      const spk = ctx.createOscillator()
      const sg = ctx.createGain()
      spk.type = 'triangle'
      spk.frequency.setValueAtTime(1319, cur + 0.18)
      sg.gain.setValueAtTime(0.0001, cur + 0.18)
      sg.gain.linearRampToValueAtTime(0.022, cur + 0.2)
      sg.gain.exponentialRampToValueAtTime(0.0001, cur + 0.55)
      spk.connect(sg).connect(ctx.destination)
      spk.start(cur + 0.18)
      spk.stop(cur + 0.6)
      _activeSoundOscs.push(spk)
      cur += noteDur + gap
    }
  } catch (_) {}
}

const playEffectSound = (type, duration, effects) => {
  const ctx = ensureAudioCtx()
  if (!ctx) return
  const dur = Math.max(0.5, duration || 5)

  const hasM = effects && effects.has('MAGNET')
  const hasI = effects && effects.has('INVINCIBLE')
  if (hasM && hasI) {
    stopEffects()
    playComboEffectSound(dur)
    return
  }

  try {
    const t = ctx.currentTime
    if (type === 'MAGNET') {
      const notes = [784, 988, 1319]
      const noteDur = 0.12
      const gap = 0.08
      let cur = t
      const endT = t + dur
      while (cur < endT) {
        for (let i = 0; i < notes.length; i++) {
          if (cur >= endT) break
          const osc = ctx.createOscillator()
          const g = ctx.createGain()
          osc.type = 'triangle'
          osc.frequency.setValueAtTime(notes[i], cur)
          g.gain.setValueAtTime(0.0001, cur)
          g.gain.linearRampToValueAtTime(0.035, cur + 0.01)
          g.gain.exponentialRampToValueAtTime(0.0001, cur + noteDur)
          osc.connect(g).connect(ctx.destination)
          osc.start(cur)
          osc.stop(cur + noteDur + 0.02)
          _activeSoundOscs.push(osc)
          cur += noteDur
        }
        cur += gap
      }
    } else if (type === 'INVINCIBLE') {
      const notes = [523, 659, 784, 988, 1175, 988, 784, 659]
      const noteDur = 0.09
      let cur = t
      const endT = t + dur
      while (cur < endT) {
        for (let i = 0; i < notes.length; i++) {
          if (cur >= endT) break
          const osc = ctx.createOscillator()
          const g = ctx.createGain()
          osc.type = 'square'
          osc.frequency.setValueAtTime(notes[i], cur)
          const atk = 0.005
          g.gain.setValueAtTime(0.0001, cur)
          g.gain.linearRampToValueAtTime(0.055, cur + atk)
          g.gain.exponentialRampToValueAtTime(0.0001, cur + noteDur)
          osc.connect(g).connect(ctx.destination)
          osc.start(cur)
          osc.stop(cur + noteDur + 0.02)
          _activeSoundOscs.push(osc)
          cur += noteDur
        }
      }
    }
  } catch (e) {}
}

export const catRunningSounds = {
  ensureAudioCtx,
  jump: jumpSound,
  hit: hitSound,
  claw: clawSound,
  playEffect: playEffectSound,
  playComboEffect: playComboEffectSound,
  stopEffects,
  tick: tickSound,
  ding: dingSound,
  pop: popSound,
  fanfare: fanfareSound,
}

export default catRunningSounds
